import { useState } from 'react';
import { urls } from '@zapier/identity-utils';

import { fetch } from '../../utils';
import { ResendStatus, UseResendSignupVerification } from './types';

/**
 * React hook that re-sends the signup verification email.
 *
 * The endpoint is enumeration-safe and always returns 200 at the application
 * level (it silently skips non-PENDING or unknown emails). A successful
 * response transitions the hook to `success`. Transport/server failures (5xx,
 * network errors) can still reject the request — the fetch wrapper throws on
 * non-2xx — so we catch and transition to `error` rather than getting stuck in
 * `submitting`; the caller can surface a retry affordance.
 */
export function useResendSignupVerification(): UseResendSignupVerification {
  const [status, setStatus] = useState<ResendStatus>('initial');

  async function resend(email: string) {
    setStatus('submitting');

    try {
      await fetch(urls.RESEND_VERIFICATION_API_URL, {
        method: 'POST',
        body: { email },
      });
      setStatus('success');
    } catch {
      setStatus('error');
    }
  }

  return {
    status,
    resend,
  };
}
